<template>
  <div v-rect-loading="loading" class="edit-company-container">
    <div class="company-editor-header">
      <div class="company-editor-title">{{ $t(`${i18nPrefix}.title.editCompanyTitle`) }}</div>
    </div>
    <CompanyProfile
      isProfileEdit
      :companyProfile="companyProfile"
      @cancel="handleCancel"
      @save="handleSave"
    ></CompanyProfile>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CompanyProfile from '@/components/company/editor/profile.vue'
import { mixedRouterPush } from '@/router/routes'

export default {
  components: {
    CompanyProfile
  },
  data () {
    return {
      i18nPrefix: 'admin.company.companyApprovalManagement',
      loading: false,
      companyProfile: {}
    }
  },
  computed: {
    isRegister () {
      return this.$route.query.isRegister || false
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('companyManagement', ['getCompanyProfileInfo', 'updateCompanyProfileInfo']),
    async initPage () {
      this.loading = true
      try {
        await Promise.all([
          this.loadCompanyInfo()
        ])
      } finally {
        this.loading = false
      }
    },
    async loadCompanyInfo () {
      const resp = await this.getCompanyProfileInfo(this.companyId)
      if (resp) {
        this.companyProfile = resp
      }
    },
    handleCancel () {
      const backUrl = this.$route.query.back
      if (backUrl) {
        mixedRouterPush(this.$route.query.back)
      } else {
        if (this.isRegister) {
          this.$router.push('/v-admin/job-list')
          return
        }
        this.$router.go(-1)
      }
    },
    async handleSave (params) {
      if (!params || !params.data) {
        return
      }
      this.loading = true
      try {
        await this.updateCompanyProfileInfo(params.data)
        if (this.companyProfile.company_info && (!this.companyProfile.company_info.step || this.companyProfile.company_info.step < 2)) {
          this.$router.push('/v-admin/company-culture?isRegister=true')
        } else {
          this.handleCancel()
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-company-container {
  width: 100%;
  min-height: 100%;
  background: #FFFFFF;
  min-width: 1320px;
  padding: 20px;
  overflow: auto;

  .company-editor-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    .company-editor-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }
}
</style>
